export default __webpack_public_path__ + "static/media/Ironman.a6e83b9e.png";